import { render, staticRenderFns } from "./Octotel.vue?vue&type=template&id=6143bcc3&scoped=true&"
import script from "./Octotel.vue?vue&type=script&lang=js&"
export * from "./Octotel.vue?vue&type=script&lang=js&"
import style0 from "./Octotel.vue?vue&type=style&index=0&id=6143bcc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143bcc3",
  null
  
)

export default component.exports